import { render, staticRenderFns } from "./Norway.vue?vue&type=template&id=479ca42a&scoped=true&"
import script from "./Norway.vue?vue&type=script&lang=ts&"
export * from "./Norway.vue?vue&type=script&lang=ts&"
import style0 from "./Norway.vue?vue&type=style&index=0&id=479ca42a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479ca42a",
  null
  
)

export default component.exports